module.exports = __webpack_public_path__ + "img/bg-pattern-1.a71ec6c2.png";